import { useState } from 'react';

export default function useDiscountApplied() {
  const [discountApplied, setDiscountApplied] = useState<{
    discount: number;
    discountType: 'percentage' | 'fixed';
  } | null>(null);
  return { discountApplied, setDiscountApplied };
}
